import { PointerEvent, SyntheticEvent } from 'react'
import Info from '../Icons/Info'
import IconButton from './IconButton'

interface IButtonInfo {
    onClick(event: SyntheticEvent): void
    onPointerEnter?(event: PointerEvent<HTMLButtonElement>): void
    onPointerLeave?(event: PointerEvent<HTMLButtonElement>): void
    color?: string
    size?: 'small' | 'medium' | 'large'
    fontSize?: 'small' | 'medium' | 'large' | 'inherit'
    showLabel?: boolean
    overrides?: string
    title?: string
}

const ButtonInfo = (props: IButtonInfo) => {
    const {
        onClick,
        onPointerEnter,
        onPointerLeave,
        color,
        fontSize,
        showLabel,
        overrides,
        title,
    } = props

    const label = showLabel && title?.length > 0 ? <span>{title}</span> : null

    return (
        <IconButton
            showLabel={showLabel}
            title={title}
            onClick={onClick}
            onPointerEnter={onPointerEnter}
            onPointerLeave={onPointerLeave}
            className={overrides}
        >
            <Info color={color} fontSize={fontSize} />
            {label}
        </IconButton>
    )
}

export default ButtonInfo
